import { render } from "./ActivityDetail.vue?vue&type=template&id=761fd38d&scoped=true&ts=true"
import script from "./ActivityDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityDetail.vue?vue&type=style&index=0&id=761fd38d&scoped=true&lang=scss"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761fd38d"],['__file',"src/views/me/ActivityDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "761fd38d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('761fd38d', __exports__)) {
    console.log('reload')
    api.reload('761fd38d', __exports__)
  }
  
  module.hot.accept("./ActivityDetail.vue?vue&type=template&id=761fd38d&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('761fd38d', render)
  })

}


export default __exports__